<template>
  <div class="display-flex">
    <span>{{ text }}</span>
      <span
        v-if="useTooltip"
        v-clipboard="{ copyText: text }"
        placement="right"
        class="m-l-5"
        v-tooltip="$t('COPY')"
      >  
        <i class="typcn typcn-tabs-outline clickable f-s-16"></i>
      </span>
       <span v-else
        v-clipboard="{ copyText: text }"
        placement="right"
        class="m-l-5"
        :title="$t('COPY')"
      >  
        <i class="typcn typcn-tabs-outline clickable f-s-16"></i>
      </span>
    </div>
</template>
<script>
import sharedMessages from '@/core/locales'
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    useTooltip: {
      type: Boolean,
      required: false,
      default: true,
    }
  },
  i18n: {
    sharedMessages,
    locale: 'en',
  }
}
</script>
